import React from 'react';
import type { JustificativaSugerida } from './useJustificativaSugerida';

interface Props {
  justificativa: JustificativaSugerida;
  rows?: number;
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
  id?: string;
}

/**
 * Caixa de texto da Justificativa SOX já preenchida com o texto sugerido. A pessoa pode editar livremente;
 * depois de editar aparece o link para voltar ao texto sugerido.
 */
const CampoJustificativaSox: React.FC<Props> = ({ justificativa, rows = 3, placeholder, className, style, id }) => (
  <>
    <textarea
      id={id}
      rows={rows}
      className={className}
      style={style}
      placeholder={placeholder}
      value={justificativa.texto}
      onChange={e => { const v = e.target.value; justificativa.editar(v); }}
    />
    <span style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 11, color: '#7e8299', fontWeight: 400, marginTop: 3 }}>
      {justificativa.editada
        ? <button type='button' className='wf-link' style={{ fontSize: 11 }} onClick={justificativa.restaurar}>↺ Usar texto sugerido</button>
        : <span>Texto sugerido. Revise e edite se precisar.</span>}
    </span>
  </>
);

export default CampoJustificativaSox;
